﻿import React, { useState } from 'react';
import { CrudFunctions } from '../../utilities/crud-functions';
import { Method } from '../../models/Methods/method';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';

import DataGrid, {
    Column,
    Selection,
    Paging,
    Sorting,
    HeaderFilter,
    FilterRow
} from 'devextreme-react/data-grid';

import { TextBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';

export interface Props {
    rowId?: string;
    gridHeight?: string;
    showTitle?: boolean;
    onApplySelection?: (item: Method) => void;
    onCancel?: () => void;
}

export default function MethodLookupComponent(props: Props) {
    const [searchString, setSearchString] =
        useState<string>();

    const [methods, setMethods] =
        useState<Method[]>();

    const [selectedMethod, setSelectedMethod] =
        useState<Method>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    return (
        <div className="pw-form-section">
            {props.showTitle &&
                <div className="lq-sub-title pw-margin-left-05 pw-margin-top-05 pw-margin-bottom-05">Methods Lookup</div>
            }

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">Search by Catalog or Lot #</label>
                    <TextBox id="catalogNumber"
                        className="textbox"
                        onValueChanged={onSearchValueChanged}
                        showClearButton={true}
                        placeholder="search string" value={searchString ? searchString : undefined} />
                </div>

                <div className="pw-row-button-13">
                    <Button id="searchButton" text="Search" icon="find" type="success"
                        className="pw-button"
                        hint="search"
                        height='2.4em'
                        onClick={onSearch} />

                </div>
            </div>

            <div className="pw-comp-row pw-margin-left-05">
                <DataGrid className="pw-no-max-width"
                    height={props.gridHeight ? props.gridHeight : "26rem"}
                    width={"100%"}
                    dataSource={methods ? methods : []}
                    onSelectionChanged={onMethodsSelectionChanged}
                    wordWrapEnabled={true}
                    showBorders={true}>

                    <Sorting mode="none" />
                    <Selection mode={'single'} />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <Paging enabled={false} />

                    <Column dataField='methodName' dataType='string' width='10rem' />
                    <Column dataField='catalogNumber' caption="Catalog #" dataType='string' width='10rem' />
                    <Column dataField='lotNumber' caption="Lot #" dataType='string' width='10rem' />
                    <Column dataField='versionNumber' caption="Version #" dataType='string' width='10rem' />
                    <Column dataField='technologyId' caption='Technology' dataType='string' width='10rem' />
                    <Column dataField='description' dataType='string' />

                </DataGrid>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button id="applySelectionButton"
                        className="pw-button"
                        text="Apply" type="success"
                        hint="apply selection"
                        height='2.6em'
                        onClick={onApplyClick} />

                    <Button id="cancelButton"
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        height='2.6em'
                        onClick={onCancelClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onSearchValueChanged(e: any) {
        setSearchString(e.value);
    }

    function onApplyClick(e: any) {
        if (selectedMethod) {

            if (props.onApplySelection)
                props.onApplySelection(selectedMethod);

        }
    }

    function onCancelClick(e: any) {
        if (props.onCancel)
            props.onCancel();
    }

    function onMethodsSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedMethod(e.selectedRowsData[0]);
        }
    }

    function onSearch(e: any) {
        if (!searchString) {
            showInformationMessage(ModalMessageType.Information, "Search Parameter Missing", "Please enter a search string.");
            return;
        }

        getMethodsBySearch();
    }

    //GET functions

    async function getMethodsBySearch() {
        CrudFunctions.getData(`methods/methodsbysearch/${searchString}`)
            .then(data => {
                setMethods(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Methods");
            });
    }

    function showInformationMessage(mode: ModalMessageType, title: string, message: string) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }


    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}

